import { ReactComponent as DownloadIcon } from 'assett/icons/download.svg';
import { ReactComponent as EditIcon } from 'assett/icons/edit.svg';
import {
	changePage,
	downloadMembersAggregationBilling,
	getCSVBillingExport,
} from 'feature/billing/billingSlice';
import { useBillingSubTab } from 'hooks/billingSubTab.hook';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from 'store/store';
import { Button, Stack } from 'styles';
import Pagination from 'styles/pagination/Pagination';
import { TRANSLATION_KEYS } from 'utils/constants';
import { useTranslation } from 'utils/translations';
import ChangeStatusModal from './ChangeStatusModal.component';

const BillingFooter = () => {
	const { t: tClientLabels } = useTranslation('', {
		keyPrefix: TRANSLATION_KEYS.CLIENT_LABELS,
	});
	const {
		pages,
		totalPages,
		claimsBilling,
		membersBilling,
		memberAggregationBilling,
	} = useSelector((store: RootState) => store.billing);
	const { view } = useBillingSubTab();
	const page = pages[view];
	const { inputBillingStatus, inputMemberBillingStatus } = useSelector(
		(store: RootState) => store.form,
	);
	const dispatch = useDispatch<AppDispatch>();

	const [open, setOpen] = useState<boolean>(false);

	const { isMembers, isMembersAggregation } = useBillingSubTab();
	const data = isMembers
		? membersBilling
		: isMembersAggregation
			? memberAggregationBilling
			: claimsBilling;

	const currentStatus = isMembers
		? inputMemberBillingStatus
		: inputBillingStatus;

	const handleChangePage = (
		event: React.ChangeEvent<unknown>,
		value: number,
	) => {
		event.preventDefault();
		dispatch(changePage({ view, page: value }));
	};

	return (
		<Stack mt={'auto'}>
			<Stack
				minHeight={100}
				direction={'row'}
				justifyContent={data.length > 0 ? 'space-between' : 'flex-end'}
				alignItems={'center'}
			>
				{data.length > 0 && (
					<Pagination page={page} count={totalPages} onChange={handleChangePage} />
				)}
				<Stack
					direction={'row'}
					justifyContent={'space-between'}
					alignItems={'center'}
					gap={'20px'}
				>
					{isMembersAggregation ? (
						<Button
							variant="contained"
							onClick={() => dispatch(downloadMembersAggregationBilling(''))}
						>
							<DownloadIcon />
							{tClientLabels('billing.action.exportPdf')}
						</Button>
					) : (
						<>
							{currentStatus !== 'settled' && (
								<Button
									variant="outlined"
									onClick={() => setOpen(true)}
									disabled={
										(currentStatus !== 'not_billed' &&
											currentStatus !== 'sent_for_billing' &&
											currentStatus !== 'billed') ||
										data.length === 0
									}
								>
									<EditIcon />
									{tClientLabels('billing.action.changeStatus')}
								</Button>
							)}
							<Button
								variant="contained"
								disabled={currentStatus === 'settled' || data.length === 0}
								onClick={() => dispatch(getCSVBillingExport(''))}
							>
								<DownloadIcon />
								{tClientLabels('billing.action.exportCsv')}
							</Button>
						</>
					)}
				</Stack>
				<ChangeStatusModal open={open} setOpen={setOpen} status={currentStatus} />
			</Stack>
		</Stack>
	);
};

export default BillingFooter;
